export default {
  "navbar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indata"])},
  "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
  "pricing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pricing"])},
  "adminmenu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin Menu"])},
  "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
  "userList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
  "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "rolePage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roles"])},
  "HomePage": {
    "linkShortener": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shortener"])}
  },
  "Dashboard": {
    "shortLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Short Link"])},
    "longLink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Long Link"])},
    "actions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions"])},
    "Modal": {
      "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
      "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])}
    },
    "DeleteModal": {
      "deleteQuestion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete"])},
      "Delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
    },
    "Button": {
      "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default"])},
      "allRecord": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Record"])}
    }
  },
  "Datatable": {
    "showrecord": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["On The Page _MENU_ Show Record"])},
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
    "paginate": {
      "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous"])},
      "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next"])}
    },
    "zeroRecord": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zero Record"])},
    "showing": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Showing _START_ to _END_ of _TOTAL_ entries"])},
    "infoEmpty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Showing 0 to 0 of 0 entries"])},
    "actions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions"])}
  },
  "userlistpage": {
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
    "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username"])},
    "mail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
    "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone Number"])},
    "actions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions"])},
    "passwordModal": {
      "changepassword": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change Password"])},
      "change": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change"])}
    },
    "deleteModal": {
      "selectedItem": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selected Item"])},
      "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
    }
  },
  "RolePage": {
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role Name"])}
  }
}